// TODO(tsgo): Remove when microsoft/typescript-go#1034 is fixed (check after tsgo 7.1+)
import { bulkAddProductLocations } from "./schema/bulk-add-product-locations";
import { bulkUpdateProductPrices } from "./schema/bulk-update-product-prices";
import { bulkUpdateForecastingFields } from "./schema/forecasting/bulk-update-forecasting-fields";
import { enrollImsBilling } from "./schema/forecasting/enroll-ims-billing";
import { getEstimatedAnnualRevenue } from "./schema/forecasting/get-estimated-annual-revenue";
import { getProductTags } from "./schema/forecasting/get-product-tags";
import { getProductVendors } from "./schema/forecasting/get-product-vendors";
import { getVariantTags } from "./schema/forecasting/get-variant-tags";
import { getImsPricingInfo } from "./schema/forecasting/ims-pricing";
import { disconnectGoogleMerchantCenter } from "./schema/google-merchant-center/disconnect-google-merchant-center";
import { getGoogleMerchantCenterIntegration } from "./schema/google-merchant-center/get-google-merchant-center-integration";
import { getGoogleMerchantCenterOAuthURL } from "./schema/google-merchant-center/get-google-merchant-center-oauth-url";
import { getMerchantCenterAccounts } from "./schema/google-merchant-center/get-merchant-center-accounts";
import { getUcpManifest } from "./schema/google-merchant-center/get-ucp-manifest";
import { updateGoogleMerchantCenterIntegration } from "./schema/google-merchant-center/update-google-merchant-center-integration";
import { getHsCodes } from "./schema/hs-code-finder/get-hs-codes";
import { searchHsCodes } from "./schema/hs-code-finder/search-hs-codes";
import { createPricingRule } from "./schema/pricing-rules/create-pricing-rule";
import { deletePricingRule } from "./schema/pricing-rules/delete-pricing-rule";
import { getPricingRules } from "./schema/pricing-rules/get-pricing-rules";
import { updatePricingRule } from "./schema/pricing-rules/update-pricing-rule";
import { getHistoricalSales } from "./schema/scenario-planning/get-historical-sales";
import { getScenarioProductPrices } from "./schema/scenario-planning/get-scenario-product-prices";
import { runScenarioForecast } from "./schema/scenario-planning/run-scenario-forecast";

export const groupB = {
  bulkAddProductLocations,
  bulkUpdateProductPrices,
  bulkUpdateForecastingFields,
  enrollImsBilling,
  getEstimatedAnnualRevenue,
  getProductTags,
  getProductVendors,
  getVariantTags,
  getImsPricingInfo,
  disconnectGoogleMerchantCenter,
  getGoogleMerchantCenterIntegration,
  getGoogleMerchantCenterOAuthURL,
  getMerchantCenterAccounts,
  getUcpManifest,
  updateGoogleMerchantCenterIntegration,
  createPricingRule,
  deletePricingRule,
  getPricingRules,
  updatePricingRule,
  getHistoricalSales,
  getScenarioProductPrices,
  runScenarioForecast,
  getHsCodes,
  searchHsCodes,
};
